<template>
  <div class="preloader">
    <half-circle-spinner :animation-duration="1000" :size="60" color="rgb(101, 91, 94)" />
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  components: {
    HalfCircleSpinner
  }
};
</script>

<style scoped lang="scss">
.preloader {
  display: flex;
  justify-content: center;
  margin-bottom: auto;
}
</style>